const teacherInfo = document.querySelectorAll('.teacher-info');

teacherInfo.forEach(e => {
  e.addEventListener('mouseenter', () => {
    e.classList.add('hover');
  });

  e.addEventListener('mouseleave', () => {
    e.classList.remove('hover');
  });

  e.addEventListener('click', () => {
    e.classList.add('hover');
  });
});